import React from 'react';
import classNames from 'classnames';
import { vars } from '$util/theme';
import styles from './index.module.scss';

export type CardShadow = 'standard' | 'big' | 'none';

export interface CardProps {
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly backgroundColor?: string;
  readonly padding?: boolean;
  readonly shadow?: CardShadow;
  readonly color?: string;
  readonly border?: boolean;
  readonly borderColor?: string;
  readonly borderStyle?: string;
}

/**
 * @deprecated
 * This component is deprecated and will be removed after migration to the new system design.
 * Use {@link Card src/components/atoms/Card/index.tsx} instead.
 */
export function Card({
  children,
  className,
  shadow = 'none',
  backgroundColor = 'white',
  border = false,
  padding = true,
  color,
  borderColor = vars.quantumverse.reskinColors.brandLightGray,
  borderStyle = 'solid',
  ...props
}: CardProps): JSX.Element {
  let boxShadow;
  switch (shadow) {
    case 'standard':
      boxShadow = vars.cardShadow;
      break;
    case 'big':
      boxShadow = vars.cardShadowBig;
      break;
    default:
      boxShadow = 'none';
  }

  let paddingValue = '0px';
  if (padding) paddingValue = border ? '19px' : '20px';

  return (
    <div
      className={classNames(styles.Card, className)}
      style={{
        backgroundColor,
        border: border ? `${borderStyle} 1px ${borderColor}` : undefined,
        color,
        boxShadow,
        padding: paddingValue,
      }}
      {...props}
    >
      {children}
    </div>
  );
}

Card.displayName = 'Card';
